import 'react';
import { BsFolderPlus } from '@react-icons/all-files/bs/BsFolderPlus';
import { decorateComponent } from '../../../documentComponents/decorateComponent.js';
import { TabItem as TabItem$1 } from './TabItem.js';
import { TabItemInspector } from './TabItem.Inspector.js';
import { jsx } from '@emotion/react';

var TabOnButtonNode = {
  key: null,
  type: 'tabButton',
  props: {
    state: 'on'
  },
  children: []
};
var TabOffButtonNode = {
  key: null,
  type: 'tabButton',
  props: {
    state: 'off'
  },
  children: []
};
var TabContentNode = {
  key: null,
  type: 'tabContent',
  props: {},
  children: []
};
var TabItem = decorateComponent(TabItem$1, 'block', {
  id: 'tabItem',
  label: '탭 항목',
  allowedParent: ['tab'],
  allowedChildren: [],
  defaultProps: {
    children: [TabOnButtonNode, TabOffButtonNode, TabContentNode]
  },
  renderIcon: function renderIcon() {
    return jsx(BsFolderPlus, null);
  },
  renderInspector: TabItemInspector
});

export { TabItem as default };
//# sourceMappingURL=index.js.map
